// Namespace for sender-to-receiver communication
export const SENDER_TO_RECEIVER_NAMESPACE = 'urn:x-cast:com.recipecast.sender.to.receiver';

// Namespace for receiver-to-sender communication
export const RECEIVER_TO_SENDER_NAMESPACE = 'urn:x-cast:com.recipecast.receiver.to.sender';

// Message types for communications
export enum MessageType {
  // Sender to receiver (common types)
  LOAD_CONTENT = 'LOAD_CONTENT',
  CUSTOM_COMMAND = 'CUSTOM_COMMAND',
  REQUEST_DEVICE_INFO = 'REQUEST_DEVICE_INFO',
  PING = 'PING',
  
  // Recipe-specific sender to receiver
  LOAD_RECIPE = 'LOAD_RECIPE',
  NEXT_STEP = 'NEXT_STEP',
  PREVIOUS_STEP = 'PREVIOUS_STEP',
  GO_TO_STEP = 'GO_TO_STEP',
  TOGGLE_INGREDIENTS = 'TOGGLE_INGREDIENTS',
  START_TIMER = 'START_TIMER',
  PAUSE_TIMER = 'PAUSE_TIMER',
  RESUME_TIMER = 'RESUME_TIMER',
  CANCEL_TIMER = 'CANCEL_TIMER',
  CHANGE_SERVINGS = 'CHANGE_SERVINGS',
  
  // Receiver to sender
  CONTENT_LOADED = 'CONTENT_LOADED',
  CONTENT_FAILED = 'CONTENT_FAILED',
  DEVICE_INFO = 'DEVICE_INFO',
  ERROR = 'ERROR',
  PONG = 'PONG',
  RECEIVER_STATE_UPDATE = 'RECEIVER_STATE_UPDATE',
  RECEIVER_CAPABILITIES = 'RECEIVER_CAPABILITIES'
}

// Navigation actions
export enum NavigationAction {
  NEXT = 'next',
  PREVIOUS = 'previous',
  GO_TO_STEP = 'goToStep'
}
